/**
 * Organization-level feature restrictions.
 * These org IDs will have specific features hidden in the UI.
 */

/** Organizations for which the "Talk to Assistant" voice call button is hidden */
export const VOICE_CALL_HIDDEN_ORG_IDS: string[] = [
  '692980852f958b7bf1c15e19',
  '695e1b4f2f958b7bf1c15eb7',
  '69831dad5c8242f68cc352b1',
];

/** Organizations for which call transcripts and conversation tabs are hidden (data protection) */
export const TRANSCRIPT_HIDDEN_ORG_IDS: string[] = [
  '68b2c499e2535d27a0eaf918',
];
